(function () {
    "use strict";

    angular.module("app").component("habilNationalities", {
        template: `<table class="table">
                    <thead>
                        <tr>
                            <th i18n="CommonTerms_SourceOfData"></th>
                            <th i18n="Person_Nationality"></th>
                            <th i18n="Person_Nationality_From"></th>
                            <th i18n="Person_Nationality_To"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="Nationality in $ctrl.nationalities | filter:{NationalityCode: '!!'}"
                            ng-class="{ 'well-foreign': Nationality.NationalityCode !== 'BE' }">
                            <td>
                                <div ng-if="Nationality.FromRR">
                                    <span class="fa-solid fa-fw fa-id-card"></span>
                                    <span i18n="DataSources_NationalRegistry"></span>
                                </div>
                                <div ng-if="!Nationality.FromRR">
                                    <span class="fa-solid fa-fw"></span>
                                    <span i18n="DataSources_Manual"></span>
                                </div>
                            </td>
                            <td>{{Nationality.NationalityCode | codeValue:$ctrl.codeNationalities}}</td>
                            <td>{{Nationality.DateFrom | date:'dd/MM/yyyy'}}</td>
                            <td>
                            <p ng-if="Nationality.DateTo">{{Nationality.DateTo | date:'dd/MM/yyyy'}}</p>
                            <p ng-if="!Nationality.DateTo">{{'Present_Date' | habilTranslation}}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>`,
        bindings: {
            nationalities: '<',            
        },
        controller: NationalityController
    });

    NationalityController.$inject = ["$rootScope"];
    function NationalityController($rootScope) {
        this.codeNationalities = $rootScope.codeCountries;
    }
})();